export default __webpack_public_path__ + "d1a180cf4bf435707e5d4f5c8a49432f.otf";